/**=====================================================================================
 * 公共模板组件
 *======================================================================================*/
const Layout = () => import("./views/layout.vue");

/**=====================================================================================
 * 登录
 *======================================================================================*/
const Login = () => import("./views/login.vue");
const authLoading = () => import("./views/auth-loading.vue");

/**=====================================================================================
 * 概况
 *======================================================================================*/
const Dashboard = () =>
  import(
    /* webpackChunkName: "group-dashboard" */ "./views/dashboard/main.vue"
  );

/**=====================================================================================
 * 数据看板
 *======================================================================================*/
const Board = () =>
  import(/* webpackChunkName: "group-board" */ "./views/board/index.vue");
const Commodity = () =>
  import(
    /* webpackChunkName: "group-board" */ "./views/board/commodity/index.vue"
  );
const Serve = () =>
  import(/* webpackChunkName: "group-board" */ "./views/board/serve/index.vue");

/**=====================================================================================
 * 商品
 *======================================================================================*/
const GoodsManageList = () =>
  import(/* webpackChunkName: "group-goods" */ "./views/goods/manage/list.vue");
const GoodsManageAdd = () =>
  import(/* webpackChunkName: "group-goods" */ "./views/goods/manage/add.vue");
const GoodsGroupList = () =>
  import(/* webpackChunkName: "group-goods" */ "./views/goods/group/list.vue");
const GoodsGroupAdd = () =>
  import(/* webpackChunkName: "group-goods" */ "./views/goods/group/add.vue");
const GoodsLinkList = () =>
  import(/* webpackChunkName: "group-goods" */ "./views/goods/link/list.vue");

/**=====================================================================================
 * 服务
 *======================================================================================*/
const serviceReservationList = () =>
  import(
    /* webpackChunkName: "group-service" */ "./views/service/reservation/list.vue"
  );
const serviceReservationAdd = () =>
  import(
    /* webpackChunkName: "group-service" */ "./views/service/reservation/add.vue"
  );
const serviceManageList = () =>
  import(
    /* webpackChunkName: "group-service" */ "./views/service/manage/list.vue"
  );
const serviceManageAdd = () =>
  import(
    /* webpackChunkName: "group-service" */ "./views/service/manage/add.vue"
  );
const serviceStoreList = () =>
  import(
    /* webpackChunkName: "group-service" */ "./views/service/store/list.vue"
  );
const serviceStoreAdd = () =>
  import(
    /* webpackChunkName: "group-service" */ "./views/service/store/add.vue"
  );

/**=====================================================================================
 * 店铺
 *======================================================================================*/
const shopComponentList = () =>
  import(
    /* webpackChunkName: "group-shop" */ "./views/shop/component/list.vue"
  );
const shopComponentIndexAdd = () =>
  import(
    /* webpackChunkName: "group-shop" */ "./views/shop/component/indexAdd.vue"
  );
const shopComponentActivityAdd = () =>
  import(
    /* webpackChunkName: "group-shop" */ "./views/shop/component/activityAdd.vue"
  );
const shopComponentCategoryAdd = () =>
  import(
    /* webpackChunkName: "group-shop" */ "./views/shop/component/categoryAdd.vue"
  );

const shopAdvList = () =>
  import(/* webpackChunkName: "group-shop" */ "./views/shop/adv/list.vue");
const shopAdvAdd = () =>
  import(/* webpackChunkName: "group-shop" */ "./views/shop/adv/add.vue");

// const shopPopularSearchList = () => import(/* webpackChunkName: "group-shop" */ './views/shop/popularsearch/list.vue')
// const shopPopularSearchAdd = () => import(/* webpackChunkName: "group-shop" */ './views/shop/popularsearch/add.vue')

const shopSet = () =>
  import(/* webpackChunkName: "group-shop" */ "./views/shop/shopset/set.vue");

/**=====================================================================================
 * 订单
 *======================================================================================*/
const orderServiceOrderList = () =>
  import(
    /* webpackChunkName: "group-order" */ "./views/order/serviceOrder/list.vue"
  );
const orderServiceOrderDetail = () =>
  import(
    /* webpackChunkName: "group-order" */ "./views/order/serviceOrder/detail.vue"
  );
const orderServiceCommentList = () =>
  import(
    /* webpackChunkName: "group-order" */ "./views/order/serviceComment/list.vue"
  );

const orderOrderList = () =>
  import(/* webpackChunkName: "group-order" */ "./views/order/order/list.vue");
const orderOrderDetail = () =>
  import(
    /* webpackChunkName: "group-order" */ "./views/order/order/detail.vue"
  );
const orderCommentList = () =>
  import(
    /* webpackChunkName: "group-order" */ "./views/order/comment/list.vue"
  );

// const orderExpressList = () => import(/* webpackChunkName: "group-order" */ './views/order/express/list.vue')
// const orderExpressAdd = () => import(/* webpackChunkName: "group-order" */ './views/order/express/add.vue')

/**=====================================================================================
 * 权限
 *======================================================================================*/
const permissionRoleList = () =>
  import(
    /* webpackChunkName: "group-permission" */ "./views/permission/role/list.vue"
  );
const permissionRoleAdd = () =>
  import(
    /* webpackChunkName: "group-permission" */ "./views/permission/role/add.vue"
  );
const permissionStaffList = () =>
  import(
    /* webpackChunkName: "group-permission" */ "./views/permission/staff/list.vue"
  );
const permissionStaffAdd = () =>
  import(
    /* webpackChunkName: "group-permission" */ "./views/permission/staff/add.vue"
  );
const permissionRecordList = () =>
  import(
    /* webpackChunkName: "group-permission" */ "./views/permission/record/list.vue"
  );
const permissionPersonalForm = () =>
  import(
    /* webpackChunkName: "group-permission" */ "./views/permission/personal/form.vue"
  );

/**=====================================================================================
 * 财务
 *======================================================================================*/
const financialSalesList = () =>
  import(
    /* webpackChunkName: "group-financial" */ "./views/financial/sales/list.vue"
  );
const financialDepositList = () =>
  import(
    /* webpackChunkName: "group-financial" */ "./views/financial/deposit/list.vue"
  );
const financialWithdrawalList = () =>
  import(
    /* webpackChunkName: "group-financial" */ "./views/financial/withdrawal/list.vue"
  );
const financialCouponExchangeList = () =>
  import(
    /* webpackChunkName: "group-financial" */ "./views/financial/couponExchange/list.vue"
  );
// const financialSaleList = () => import(/* webpackChunkName: "group-financial" */ './views/financial/sale/list.vue')

/**=====================================================================================
 * 运营
 *======================================================================================*/
const marketingCouponList = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/coupon/list.vue"
  );
const marketingCouponAdd = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/coupon/add.vue"
  );
const marketingCouponDetail = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/coupon/detail.vue"
  );
const marketingCouponExchangeList = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/couponExchange/list.vue"
  );
const marketingCouponExchangeAdd = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/couponExchange/add.vue"
  );
const marketingCouponExchangeDetail = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/couponExchange/detail.vue"
  );
const marketingPointsList = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/points/list.vue"
  );
const marketingPointsAdd = () =>
  import(
    /* webpackChunkName: "group-marketing" */ "./views/marketing/points/add.vue"
  );
// const marketingPromotionList = () => import(/* webpackChunkName: "group-marketing" */ './views/marketing/promotion/list.vue')
// const marketingPromotionAdd = () => import(/* webpackChunkName: "group-marketing" */ './views/marketing/promotion/add.vue')
// const marketingGiftList = () => import(/* webpackChunkName: "group-marketing" */ './views/marketing/gift/list.vue')
// const marketingGiftAdd = () => import(/* webpackChunkName: "group-marketing" */ './views/marketing/gift/add.vue')

/**=====================================================================================
 * 代理
 *======================================================================================*/
const agentCompanyList = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/company/list.vue"
  );
const agentCompanyAdd = () =>
  import(/* webpackChunkName: "group-agent" */ "./views/agent/company/add.vue");
const agentCompanyDetail = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/company/detail.vue"
  );
const agentCompanyGoodsLevel = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/company/goodsLevel.vue"
  );
const agentCompanyServiceLevel = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/company/serviceLevel.vue"
  );
const agentPersonList = () =>
  import(/* webpackChunkName: "group-agent" */ "./views/agent/person/list.vue");
const agentPersonAdd = () =>
  import(/* webpackChunkName: "group-agent" */ "./views/agent/person/add.vue");
const agentPersonDetail = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/person/detail.vue"
  );
const agentPersonGoodsLevel = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/person/goodsLevel.vue"
  );
const agentPersonServiceLevel = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/person/serviceLevel.vue"
  );
const agentServiceLevel = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/service/level.vue"
  );
const agentGoodsLevel = () =>
  import(/* webpackChunkName: "group-agent" */ "./views/agent/goods/level.vue");
const agentUserList = () =>
  import(/* webpackChunkName: "group-user" */ "./views/agent/user/list.vue");
const agentUserDetail = () =>
  import(/* webpackChunkName: "group-user" */ "./views/agent/user/detail.vue");
const agentUserLevel = () =>
  import(/* webpackChunkName: "group-user" */ "./views/agent/user/level.vue");
const agentEmployeeList = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/employee/list.vue"
  );
const agentEmployeeAdd = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/employee/add.vue"
  );

const agentRevenue = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/revenue/index.vue"
  );
const agentUserRankList = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/userRank/list.vue"
  );
const agentChildAgentRankList = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/childAgentRank/list.vue"
  );
const agentChildAgentManageList = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/childAgentManage/list.vue"
  );
const agentChildAgentManageAdd = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/childAgentManage/add.vue"
  );
const agentWithdrawalList = () =>
  import(
    /* webpackChunkName: "group-agent" */ "./views/agent/withdrawal/list.vue"
  );
// 业绩
const performance = () =>
  import(
    /* webpackChunkName: "performance" */ "./views/performance/performance-objectives/index.vue"
  );

/**=====================================================================================
 * 分销
 *======================================================================================*/
// const distributionCommissionList = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/commission/list.vue')
// const distributionCommissionAdd = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/commission/add.vue')
// const distributionDistributorList = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/distributor/list.vue')
// const distributionDistributorMember = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/distributor/member.vue')
// const distributionDistributorOrder = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/distributor/order.vue')
// const distributionWithdrawList = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/withdraw/list.vue')
// const distributionBankList = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/bank/list.vue')
// const distributionBankAdd = () => import(/* webpackChunkName: "group-distribution" */ './views/distribution/bank/add.vue')

export default {
  routes: [
    /**=====================================================================================
     * 登录
     *======================================================================================*/
    {
      path: "/login",
      name: "登录",
      component: Login,
      meta: {
        noAuth: true,
      },
    },
    {
      path: "/auth-loading",
      name: "授权登录",
      component: authLoading,
      meta: {
        noAuth: true,
      },
    },
  ],
  /**
   * [getRoutesList description] 根据权限组装路由
   * @param  {[type]} ids [description] isLogin接口返回的权限id列表
   * @return {[type]}     [description]
   */
  getRoutesList: function (ids) {
    let navs = [],
      list = [],
      sublist = [];

    let boardChildren = [];
    // 商品看板权限检查
    if (ids.indexOf(47) > -1) {
      boardChildren.push({
        path: "/board/commodity",
        name: "board-commodity",
        component: Commodity,
        meta: {
          parent: "数据看板",
          title: "商品看板",
        },
      });
    }
    // 服务看板权限检查
    if (ids.indexOf(48) > -1) {
      boardChildren.push({
        path: "/board/serve",
        name: "board-serve",
        component: Serve,
        meta: {
          parent: "数据看板",
          title: "服务看板",
        },
      });
    }
    // 组装带有顶部 Tabs (Board组件) 的父级看板路由
    if (boardChildren.length > 0) {
      navs.push({
        path: "/board",
        name: "看板",
        component: Layout, // 外层使用全局 Layout 组件，确保顶部面包屑与用户信息正常显示
        redirect: boardChildren[0].path, // 智能重定向到当前拥有的第一个有权限的子看板
        meta: {
          alias: "s-marketing",
          title: "首页数据看板",
          hideSubmenu: true, // 隐藏左侧展开栏直接显示为一级菜单
        },
        children: [
          {
            path: "",
            component: Board, // 中间层渲染包含顶部 Tabs 切换选项和子 router-view 的组件
            redirect: boardChildren[0].path,
            children: boardChildren,
          },
        ],
      });
    }
    // 别删，如果后续添加了编辑看板的路由，要按照这个格式添加
    // if (ids.indexOf(50) > -1) {
    //   navs.push({
    //     path: '/board/serve/edit',
    //     name: 'board-serve-edit',
    //     component: ServeEdit, // 直接挂载编辑组件，不再套用 Board 容器
    //     meta: {
    //       parent: '数据看板',
    //       title: '编辑服务看板',
    //       // 关键点：绝不能配置 meta.alias 属性！
    //     },
    //   })
    // }

    /**=====================================================================================
     * 店铺 shop
     * 4 > 5 > 5
     * 4 > 6 > 6
     * 4 > 7 > 7
     * 4 > 8 > 8
     * 4 > 9 > 9
     *======================================================================================*/
    list = [];

    // 组件管理 =====================================
    if (ids.indexOf(5) > -1) {
      list.push({
        path: "/shop/component/list",
        name: "shop-component-list",
        nameDisplay: "组件管理",
        component: shopComponentList,
        meta: {
          parent: "店铺管理",
          title: "组件管理",
        },
      });
      list.push({
        path: "/shop/component/index",
        name: "shop-component-index",
        nameDisplay: "组件管理",
        component: shopComponentIndexAdd,
        meta: {
          parent: "店铺管理",
          title: "新建组件",
          hidden: true,
        },
      });
      list.push({
        path: "/shop/component/activity",
        name: "shop-component-activity",
        nameDisplay: "组件管理",
        component: shopComponentActivityAdd,
        meta: {
          parent: "店铺管理",
          title: "新建组件",
          hidden: true,
        },
      });
      list.push({
        path: "/shop/component/category",
        name: "shop-component-category",
        nameDisplay: "组件管理",
        component: shopComponentCategoryAdd,
        meta: {
          parent: "店铺管理",
          title: "新建组件",
          hidden: true,
        },
      });
    }

    // 广告管理 =====================================
    if (ids.indexOf(6) > -1) {
      list.push({
        path: "/shop/adv/list",
        name: "shop-adv-list",
        nameDisplay: "广告管理",
        component: shopAdvList,
        meta: {
          parent: "店铺管理",
          title: "广告管理",
        },
      });
      list.push({
        path: "/shop/adv/add",
        name: "shop-adv-add",
        nameDisplay: "广告管理",
        component: shopAdvAdd,
        meta: {
          parent: "店铺管理",
          title: "新增广告",
          hidden: true,
        },
      });
    }

    // 店铺设置 =====================================
    if (ids.indexOf(36) > -1) {
      list.push({
        path: "/shop/set",
        name: "shop-set",
        nameDisplay: "店铺设置",
        component: shopSet,
        meta: {
          parent: "店铺管理",
          title: "店铺设置",
        },
      });
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "店铺",
        component: Layout,
        meta: {
          alias: "shop",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 服务 service
     * 50 > 51 > 51
     * 50 > 52 > 52
     * 50 > 53 > 53
     *======================================================================================*/
    list = [];

    // 服务预约 =====================================
    if (ids.indexOf(51) > -1) {
      list.push({
        path: "/service/reservation/list",
        name: "service-reservation-list",
        nameDisplay: "服务预约",
        component: serviceReservationList,
        meta: {
          parent: "服务管理",
          title: "服务预约",
        },
      });
      list.push({
        path: "/service/reservation/add",
        name: "service-reservation-add",
        nameDisplay: "服务预约",
        component: serviceReservationAdd,
        meta: {
          parent: "服务管理",
          title: "完善预约信息",
          hidden: true,
        },
      });
    }

    // 服务设置 =====================================
    if (ids.indexOf(52) > -1) {
      list.push({
        path: "/service/manage/list",
        name: "service-manage-list",
        nameDisplay: "服务设置",
        component: serviceManageList,
        meta: {
          parent: "服务管理",
          title: "服务设置",
        },
      });
      list.push({
        path: "/service/manage/add",
        name: "service-manage-add",
        nameDisplay: "服务设置",
        component: serviceManageAdd,
        meta: {
          parent: "服务管理",
          title: "发布服务",
          editTitle: "编辑服务",
          hidden: true,
        },
      });
    }

    // 门店信息 =====================================
    if (ids.indexOf(53) > -1) {
      list.push({
        path: "/service/store/list",
        name: "service-store-list",
        nameDisplay: "门店信息",
        component: serviceStoreList,
        meta: {
          parent: "服务管理",
          title: "门店信息",
        },
      });
      list.push({
        path: "/service/store/add",
        name: "service-store-add",
        nameDisplay: "门店信息",
        component: serviceStoreAdd,
        meta: {
          parent: "服务管理",
          title: "门店信息",
          hidden: true,
        },
      });
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "服务",
        component: Layout,
        meta: {
          alias: "service",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 订单 order
     * 10 > 54 > 54
     * 10 > 55 > 55
     * 10 > 11 > 11
     * 10 > 12 > 12
     * 10 > 13 > 13
     *======================================================================================*/
    list = [];

    // 服务订单查询 =====================================
    if (ids.indexOf(54) > -1) {
      list.push(
        {
          path: "/order/service/order/list",
          name: "order-service-order-list",
          nameDisplay: "服务订单",
          component: orderServiceOrderList,
          meta: {
            parent: "订单管理",
            title: "服务订单查询",
            keepAlive: true,
          },
        },
        {
          path: "/order/service/order/detail",
          name: "order-service-order-detail",
          nameDisplay: "服务订单",
          component: orderServiceOrderDetail,
          meta: {
            parent: "订单管理",
            title: "服务订单详情",
            hidden: true,
          },
        },
      );
    }

    // 服务评价管理 =====================================
    if (ids.indexOf(55) > -1) {
      list.push({
        path: "/order/service/comment/list",
        name: "order-service-comment-list",
        nameDisplay: "服务评价",
        component: orderServiceCommentList,
        meta: {
          parent: "订单管理",
          title: "服务评价管理",
        },
      });
    }

    // 商品订单查询 =====================================
    if (ids.indexOf(11) > -1) {
      list.push(
        {
          path: "/order/order/list",
          name: "order-order-list",
          nameDisplay: "商品订单",
          component: orderOrderList,
          meta: {
            parent: "订单管理",
            title: "商品订单查询",
            keepAlive: true,
          },
        },
        {
          path: "/order/order/detail",
          name: "order-order-detail",
          nameDisplay: "商品订单",
          component: orderOrderDetail,
          meta: {
            parent: "订单管理",
            title: "商品订单详情",
            hidden: true,
          },
        },
      );
    }

    // 商品评价管理 =====================================
    if (ids.indexOf(12) > -1) {
      list.push({
        path: "/order/comment/list",
        name: "order-comment-list",
        nameDisplay: "商品评价",
        component: orderCommentList,
        meta: {
          parent: "订单管理",
          title: "商品评价管理",
        },
      });
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        // path: "/order",
        path: list[0].path,
        name: "订单",
        component: Layout,
        meta: {
          alias: "order",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 顾客 user
     * 60 > 60
     *======================================================================================*/
    list = [];
    if (ids.indexOf(60) > -1) {
      list.push(
        {
          path: "/agent/user/list",
          name: "agent-user-list",
          nameDisplay: "会员中心",
          component: agentUserList,
          meta: {
            parent: "会员管理",
            title: "会员管理",
            keepAlive: true,
          },
        },
        {
          path: "/agent/user/detail",
          name: "agent-user-detail",
          nameDisplay: "会员",
          component: agentUserDetail,
          meta: {
            parent: "会员管理",
            title: "会员详情",
            hidden: true,
          },
        },
        {
          path: "/agent/user/level",
          name: "agent-user-level",
          nameDisplay: "会员",
          component: agentUserLevel,
          meta: {
            parent: "会员管理",
            title: "会员等级设置",
            hidden: true,
          },
        },
      );
    }

    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "会员",
        component: Layout,
        meta: {
          alias: "user",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 商品 goods
     * 2 > 3 > 3
     *======================================================================================*/
    list = [];

    // 商品管理 =====================================
    if (ids.indexOf(3) > -1) {
      list.push({
        path: "/goods/manage/list",
        name: "goods-manage-list",
        nameDisplay: "商品管理",
        component: GoodsManageList,
        meta: {
          parent: "商品管理",
          title: "商品管理",
          keepAlive: true,
        },
      });
      list.push({
        path: "/goods/manage/add",
        name: "goods-manage-add",
        nameDisplay: "商品管理",
        component: GoodsManageAdd,
        meta: {
          parent: "商品管理",
          title: "发布商品",
          editTitle: "编辑商品",
          hidden: true,
        },
      });
    }

    // 商品专链 =====================================
    if (ids.indexOf(49) > -1) {
      list.push({
        path: "/goods/link/list",
        name: "goods-link-list",
        nameDisplay: "商品专链",
        component: GoodsLinkList,
        meta: {
          parent: "商品管理",
          title: "商品专链",
          keepAlive: true,
        },
      });
    }

    // 商品分组 =====================================
    if (ids.indexOf(50) > -1) {
      list.push({
        path: "/goods/group/list",
        name: "goods-group-list",
        nameDisplay: "商品组合",
        component: GoodsGroupList,
        meta: {
          parent: "商品管理",
          title: "商品组合",
        },
      });
      list.push({
        path: "/goods/group/add",
        name: "goods-group-add",
        nameDisplay: "商品组合",
        component: GoodsGroupAdd,
        meta: {
          parent: "商品管理",
          title: "新增组合",
          editTitle: "编辑组合",
          hidden: true,
        },
      });
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "商品",
        component: Layout,
        meta: {
          alias: "goods",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 代理 agent
     * 57 > 58 > 58
     * 57 > 59 > 59
     * 57 > 60 > 60
     * 57 > 61 > 61
     *======================================================================================*/
    list = [];

    // 公司代理 =====================================
    if (ids.indexOf(58) > -1) {
      list.push(
        {
          path: "/agent/company/list",
          name: "agent-company-list",
          nameDisplay: "公司代理",
          component: agentCompanyList,
          meta: {
            parent: "分销管理",
            title: "公司代理",
          },
        },
        {
          path: "/agent/company/add",
          name: "agent-company-add",
          nameDisplay: "公司代理",
          component: agentCompanyAdd,
          meta: {
            parent: "分销管理",
            title: "新增公司代理",
            hidden: true,
          },
        },
        {
          path: "/agent/company/detail",
          name: "agent-company-detail",
          nameDisplay: "公司代理",
          component: agentCompanyDetail,
          meta: {
            parent: "分销管理",
            title: "公司代理详情",
            hidden: true,
          },
        },
        {
          path: "/agent/company/goodsLevel",
          name: "agent-company-goodsLevel",
          nameDisplay: "公司代理",
          component: agentCompanyGoodsLevel,
          meta: {
            parent: "分销管理",
            title: "商品分佣设置",
            hidden: true,
          },
        },
        {
          path: "/agent/company/serviceLevel",
          name: "agent-company-serviceLevel",
          nameDisplay: "公司代理",
          component: agentCompanyServiceLevel,
          meta: {
            parent: "分销管理",
            title: "服务分佣设置",
            hidden: true,
          },
        },
      );
    }

    // 个人代理 =====================================
    if (ids.indexOf(59) > -1) {
      list.push(
        {
          path: "/agent/person/list",
          name: "agent-person-list",
          nameDisplay: "个人代理",
          component: agentPersonList,
          meta: {
            parent: "分销管理",
            title: "个人代理",
          },
        },
        {
          path: "/agent/person/add",
          name: "agent-person-add",
          nameDisplay: "个人代理",
          component: agentPersonAdd,
          meta: {
            parent: "分销管理",
            title: "新增个人代理",
            hidden: true,
          },
        },
        {
          path: "/agent/person/detail",
          name: "agent-person-detail",
          nameDisplay: "个人代理",
          component: agentPersonDetail,
          meta: {
            parent: "分销管理",
            title: "个人代理详情",
            hidden: true,
          },
        },
        {
          path: "/agent/person/goodsLevel",
          name: "agent-person-goodsLevel",
          nameDisplay: "个人代理",
          component: agentPersonGoodsLevel,
          meta: {
            parent: "分销管理",
            title: "商品分佣设置",
            hidden: true,
          },
        },
        {
          path: "/agent/person/serviceLevel",
          name: "agent-person-serviceLevel",
          nameDisplay: "个人代理",
          component: agentPersonServiceLevel,
          meta: {
            parent: "分销管理",
            title: "服务分佣设置",
            hidden: true,
          },
        },
      );
    }

    // 分销收益 =====================================
    if (ids.indexOf(65) > -1) {
      list.push({
        path: "/agent/revenue/list",
        name: "agent-revenue-list",
        nameDisplay: "分销收益",
        component: agentRevenue,
        meta: {
          parent: "分销管理",
          title: "分销收益",
        },
      });
    }

    // 员工排行 =====================================
    if (ids.indexOf(66) > -1) {
      list.push({
        path: "/agent/userRank/list",
        name: "agent-userRank-list",
        nameDisplay: "员工排行",
        component: agentUserRankList,
        meta: {
          parent: "分销管理",
          title: "员工排行",
        },
      });
    }

    // 员工管理 =====================================
    if (ids.indexOf(61) > -1) {
      list.push(
        {
          path: "/agent/employee/list",
          name: "agent-employee-list",
          nameDisplay: "员工管理",
          component: agentEmployeeList,
          meta: {
            parent: "代理管理",
            title: "员工管理",
          },
        },
        {
          path: "/agent/employee/add",
          name: "agent-employee-add",
          nameDisplay: "员工管理",
          component: agentEmployeeAdd,
          meta: {
            parent: "代理管理",
            title: "新增员工",
            hidden: true,
          },
        },
      );
    }

    // 子代理排行 =====================================
    if (ids.indexOf(67) > -1) {
      list.push({
        path: "/agent/childAgentRank/list",
        name: "agent-childAgentRank-list",
        nameDisplay: "子代理排行",
        component: agentChildAgentRankList,
        meta: {
          parent: "分销管理",
          title: "子代理排行",
        },
      });
    }

    // 子代理管理 =====================================
    if (ids.indexOf(68) > -1) {
      list.push(
        {
          path: "/agent/childAgentManage/list",
          name: "agent-childAgentManage-list",
          nameDisplay: "子代理管理",
          component: agentChildAgentManageList,
          meta: {
            parent: "分销管理",
            title: "子代理管理",
          },
        },
        {
          path: "/agent/childAgentManage/add",
          name: "agent-childAgentManage-add",
          nameDisplay: "子代理管理",
          component: agentChildAgentManageAdd,
          meta: {
            parent: "分销管理",
            title: "添加子代理",
            hidden: true,
          },
        },
        {
          path: "/agent/childAgentManage/company/detail",
          name: "agent-childAgentManage-company-detail",
          nameDisplay: "子代理管理",
          component: agentCompanyDetail,
          meta: {
            parent: "分销管理",
            title: "子代理(公司)详情",
            hidden: true,
          },
        },
        {
          path: "/agent/childAgentManage/person/detail",
          name: "agent-childAgentManage-person-detail",
          nameDisplay: "子代理管理",
          component: agentPersonDetail,
          meta: {
            parent: "分销管理",
            title: "子代理(个人)详情",
            hidden: true,
          },
        },
      );
    }

    // 提现记录 =====================================
    if (ids.indexOf(69) > -1) {
      list.push({
        path: "/agent/withdrawal/list",
        name: "agent-withdrawal-list",
        nameDisplay: "提现记录",
        component: agentWithdrawalList,
        meta: {
          parent: "分销管理",
          title: "提现记录",
        },
      });
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "分销",
        component: Layout,
        meta: {
          alias: "distribution",
        },
        children: list,
      });
    }

    // /**=====================================================================================
    //  * 分销 distribution
    //  * 40 > 41 > 41
    //  * 40 > 42 > 42
    //  * 40 > 43 > 43
    //  * 40 > 44 > 44
    //  *======================================================================================*/
    // list = [];

    /**=====================================================================================
     * 财务 permission
     * 25 > 26 > 26
     * 25 > 27 > 27
     * 25 > 28 > 28
     * 25 > 29 > 29
     * 25 > 30 > 30
     * 25 > 63 > 63
     *======================================================================================*/
    list = [];

    // 销售数据 =====================================
    if (ids.indexOf(70) > -1) {
      list.push({
        path: "/financial/sales/list",
        name: "financial-sales-list",
        nameDisplay: "销售数据",
        component: financialSalesList,
        meta: {
          parent: "财务管理",
          title: "销售数据",
        },
      });
    }

    // 退款审核 =====================================
    if (ids.indexOf(27) > -1) {
      list.push({
        path: "/financial/deposit/list",
        name: "financial-deposit-list",
        nameDisplay: "退款审核",
        component: financialDepositList,
        meta: {
          parent: "财务管理",
          title: "退款审核",
        },
      });
    }

    // 提现明细 =====================================
    if (ids.indexOf(71) > -1) {
      list.push({
        path: "/financial/withdrawal/list",
        name: "financial-withdrawal-list",
        nameDisplay: "提现明细",
        component: financialWithdrawalList,
        meta: {
          parent: "财务管理",
          title: "提现明细",
        },
      });
    }

    // 兑换券核销 =====================================
    if (ids.indexOf(63) > -1) {
      list.push({
        path: "/financial/coupon/exchange/list",
        name: "financial-coupon-exchange-list",
        nameDisplay: "兑换券核销",
        component: financialCouponExchangeList,
        meta: {
          parent: "财务管理",
          title: "兑换券核销",
        },
      });
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "财务",
        component: Layout,
        meta: {
          alias: "caiwu",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 权限 permission
     * 31 > 32 > 32
     * 31 > 33 > 33
     * 31 > 34 > 34
     *======================================================================================*/
    list = [];

    // 员工管理 =====================================
    if (ids.indexOf(32) > -1) {
      list.push(
        {
          path: "/permission/staff/list",
          name: "permission-staff-list",
          nameDisplay: "员工管理",
          component: permissionStaffList,
          meta: {
            parent: "角色权限",
            title: "员工管理",
          },
        },
        {
          path: "/permission/staff/add",
          name: "permission-staff-add",
          nameDisplay: "员工管理",
          component: permissionStaffAdd,
          meta: {
            parent: "角色权限",
            title: "添加员工",
            hidden: true,
          },
        },
      );
    }

    // 角色管理 =====================================
    if (ids.indexOf(33) > -1) {
      list.push({
        path: "/permission/role/list",
        name: "permission-role-list",
        nameDisplay: "角色管理",
        component: permissionRoleList,
        meta: {
          parent: "角色权限",
          title: "角色权限",
        },
      });
      list.push({
        path: "/permission/role/add",
        name: "permission-role-add",
        nameDisplay: "角色管理",
        component: permissionRoleAdd,
        meta: {
          parent: "角色权限",
          title: "管理角色权限",
          hidden: true,
        },
      });
    }

    // 操作日志 =====================================
    if (ids.indexOf(34) > -1) {
      list.push({
        path: "/permission/record/list",
        name: "permission-record-list",
        nameDisplay: "操作日志",
        component: permissionRecordList,
        meta: {
          parent: "角色权限",
          title: "操作日志",
        },
      });
    }

    // 个人中心 =====================================
    if (ids.indexOf(35) > -1) {
      list.push({
        path: "/permission/personal/form",
        name: "permission-personal-form",
        nameDisplay: "个人中心",
        component: permissionPersonalForm,
        meta: {
          parent: "个人中心",
          title: "修改密码",
        },
      });
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "权限",
        component: Layout,
        meta: {
          alias: "permission",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 营销 marketing
     * 37 > 38 > 38
     * 37 > 39 > 39
     * 37 > 62 > 62
     *======================================================================================*/
    list = [];

    // 优惠券 =====================================
    if (ids.indexOf(38) > -1) {
      list.push(
        {
          path: "/marketing/coupon/list",
          name: "marketing-coupon-list",
          nameDisplay: "优惠券",
          component: marketingCouponList,
          meta: {
            parent: "营销管理",
            title: "优惠券",
          },
        },
        {
          path: "/marketing/coupon/detail",
          name: "marketing-coupon-detail",
          nameDisplay: "优惠券",
          component: marketingCouponDetail,
          meta: {
            parent: "营销管理",
            title: "优惠券详情",
            hidden: true,
          },
        },
        {
          path: "/marketing/coupon/add",
          name: "marketing-coupon-add",
          nameDisplay: "优惠券",
          component: marketingCouponAdd,
          meta: {
            parent: "营销管理",
            title: "新建优惠券",
            hidden: true,
          },
        },
      );
    }

    // 兑换券 =====================================
    if (ids.indexOf(62) > -1) {
      list.push(
        {
          path: "/marketing/coupon/exchange/list",
          name: "marketing-coupon-exchange-list",
          nameDisplay: "兑换券",
          component: marketingCouponExchangeList,
          meta: {
            parent: "营销管理",
            title: "兑换券",
          },
        },
        {
          path: "/marketing/coupon/exchange/detail",
          name: "marketing-coupon-exchange-detail",
          nameDisplay: "兑换券",
          component: marketingCouponExchangeDetail,
          meta: {
            parent: "营销管理",
            title: "兑换券详情",
            hidden: true,
          },
        },
        {
          path: "/marketing/coupon/exchange/add",
          name: "marketing-coupon-exchange-add",
          nameDisplay: "兑换券",
          component: marketingCouponExchangeAdd,
          meta: {
            parent: "营销管理",
            title: "新建兑换券",
            hidden: true,
          },
        },
      );
    }

    // 积分中心 =====================================
    if (ids.indexOf(64) > -1) {
      list.push(
        {
          path: "/marketing/points/list",
          name: "marketing-points-list",
          nameDisplay: "积分中心",
          component: marketingPointsList,
          meta: {
            parent: "营销管理",
            title: "积分中心",
          },
        },
        {
          path: "/marketing/points/add",
          name: "marketing-points-add",
          nameDisplay: "积分中心",
          component: marketingPointsAdd,
          meta: {
            parent: "营销管理",
            title: "新建积分商品",
            editTitle: "编辑积分商品",
            hidden: true,
          },
        },
      );
    }

    //  =====================================
    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "营销",
        component: Layout,
        meta: {
          alias: "marketing",
        },
        children: list,
      });
    }

    /**=====================================================================================
     * 业绩 performance
     *======================================================================================*/
    list = [];
    if (ids.indexOf(100) > -1) {
      list.push({
        path: "/performance/performance-objectives",
        name: "performance-objectives",
        nameDisplay: "业绩目标",
        component: performance,
        meta: {
          parent: "业绩目标",
          title: "业绩目标",
        },
      });
    }

    if (list.length > 0) {
      navs.push({
        path: list[0].path,
        name: "目标",
        component: Layout,
        meta: {
          alias: "performance",
        },
        children: list,
      });
    }
    /**=====================================================================================
     * 数据看板 board
     *======================================================================================*/
    // navs.push({
    //   path: '/board',
    //   name: '看板',
    //   component: Board,
    //   meta: {
    //     alias: 's-marketing',
    //     title: '首页数据看板',
    //   },
    // })

    this.setRoutesStorage(navs);

    return navs;
  },

  /**
   * [setRoutesStorage description] 将完整的route结构存本地，供左侧导航渲染使用
   * @param {[type]} list [description]
   */
  setRoutesStorage: function (list) {
    let lists = this.routes.concat(list);
    localStorage.setItem("routes", JSON.stringify(lists));
  },

  hasPermission: function (toPath) {
    const routesStr = localStorage.getItem("routes");
    if (!routesStr) return false;
    let lists = [];
    try {
      lists = JSON.parse(routesStr) || [];
    } catch (e) {
      return false;
    }
    const paths = [];
    // 递归收集所有子路由的 path
    const collectPaths = (items) => {
      items.forEach((item) => {
        if (item.path) {
          paths.push(item.path);
        }
        if (item.children && item.children.length > 0) {
          collectPaths(item.children);
        }
      });
    };
    collectPaths(lists);
    return paths.includes(toPath);
  },
};
